import { SortDirectionEnum } from '../../enums/sort-direction.enum';

export const MAX_WEEK_FORWARD = 12;
export const MAX_WEEK_BACKWARD = 12;
export const SORT_ORDER = SortDirectionEnum.ASC;
